// Walk-over (WO) y marcador de un partido.
//
// Un equipo puede dar walk-over: no se presenta y pierde el partido 3 a 0. El
// partido queda `jugado`, sin goleadores, y `wo` dice qué lado lo dio:
// "home" | "away" | "both" ("both" = no se presentó ninguno de los dos).
//
// El marcador NO se guarda: se deriva del WO o, si no lo hay, de la cantidad de
// goles cargados. Por eso todo lo que muestre un resultado (tabla de posiciones,
// pantallas públicas, planillas) pasa por `marcadorDePartido`.
//
// El WO doble es el caso raro: no se presentó ninguno de los dos, así que el
// partido SÍ cuenta como jugado y los dos lo pierden (PJ y PP para cada uno, sin
// puntos). Cada equipo recibe 3 goles en contra y ninguno convierte.

export const GOLES_WO = 3;

// "home" | "away" | "both" | null — el lado (o los dos) que dio el walk-over.
export const ladoWO = (match) => {
  const wo = match && match.wo;
  return wo === "home" || wo === "away" || wo === "both" ? wo : null;
};

export const esWO = (match) => ladoWO(match) != null;

// Los dos equipos dieron walk-over.
export const esWODoble = (match) => ladoWO(match) === "both";

// ¿Ese lado dio el walk-over? Sirve tanto con un partido como con el valor de `wo`.
export const daWO = (wo, side) => wo === side || wo === "both";

// Marca o desmarca el WO de un lado, respetando el del otro:
// "" -> "home" -> "both" -> "away" -> "" (según de qué lado se toque).
export function alternarWO(wo, side) {
  const otro = side === "home" ? "away" : "home";
  const loDaElOtro = daWO(wo, otro);
  if (daWO(wo, side)) return loDaElOtro ? otro : "";
  return loDaElOtro ? "both" : side;
}

// { local, visitante } con los goles CONVERTIDOS por cada lado. En el WO doble
// nadie convirtió: los 3 goles en contra de cada uno no son goles a favor del
// rival, así que la tabla de posiciones los suma aparte (ver standings.js), y el
// 0 a 0 que devuelve acá NO es un empate: el partido lo pierden los dos.
export function marcadorDePartido(match) {
  const lado = ladoWO(match);
  if (lado === "home") return { local: 0, visitante: GOLES_WO };
  if (lado === "away") return { local: GOLES_WO, visitante: 0 };
  if (lado === "both") return { local: 0, visitante: 0 };
  return {
    local: ((match && match.homeGoals) || []).length,
    visitante: ((match && match.awayGoals) || []).length,
  };
}
